import commercialCabinImg from "../../assets/comarcial-project/cabin 2.1.png";
import commercialReceptionImg from "../../assets/comarcial-project/Enscape_2025-01-07-18-27-04.png";
import commercialWorkAreaImg from "../../assets/comarcial-project/Enscape_2025-01-07-19-06-48.png";
import commercialMeetingImg from "../../assets/comarcial-project/Enscape_2025-01-17-14-06-31.png";
import commercialCorridorImg from "../../assets/comarcial-project/Enscape_2025-01-17-15-06-01.png";
import commercialStorageImg from "../../assets/comarcial-project/Enscape_2025-01-18-18-55-52.png";
import commercialPantryImg from "../../assets/comarcial-project/Enscape_2025-01-18-18-56-53.png";
import commercialDetailImg from "../../assets/comarcial-project/Enscape_2025-01-20-13-50-11.png";
import commercialFrontImg from "../../assets/comarcial-project/Enscape_2025-02-14-16-48-54.png";

const UpComingProject = {
    title: "Commercial Project",
    category: "Commercial Interior",
    facts: [
      { label: "Location", value: "Wakad" },
      { label: "Year", value: "Upcoming" },
      { label: "Area", value: "450 sq ft" },
      { label: "Category", value: "Commercial Interior" },
      { label: "Services", value: "Commercial Interior" },
    ],
    heroImage: commercialMeetingImg,
    heroAlt: "Upcoming commercial interior front view in Wakad",
    overview:
      "An upcoming commercial interior project in Wakad planned around compact workplace function, clean visitor experience and efficient use of 450 sq ft.",
    fullbleedImage: commercialReceptionImg,
    fullbleedAlt: "Commercial reception interior render",
    fullbleedQuote:
      "Compact commercial spaces need clarity, storage and a sharp first impression.",
    chapters: [
      {
        eyebrow: "01 - Front",
        title: "First Impression",
        body: "The entry view is planned to feel clean, direct and professional within a compact footprint.",
        image: commercialReceptionImg,
        alt: "Commercial reception interior render",
      },
      {
        eyebrow: "02 - Work Area",
        title: "Efficient Layout",
        body: "Workstations and circulation are arranged so the space stays functional without feeling crowded.",
        image: commercialCorridorImg,
        alt: "Commercial circulation and work area render",
      },
      {
        eyebrow: "03 - Cabin",
        title: "Focused Cabin",
        body: "The cabin zone gives the project a private working pocket with a composed material palette.",
        image: commercialStorageImg,
        alt: "Commercial storage and workstation render",
      },
      {
        eyebrow: "04 - Meeting",
        title: "Client Conversation",
        body: "Meeting and discussion areas are designed for quick reviews, client interaction and daily coordination.",
        image: commercialCabinImg,
        alt: "Commercial cabin meeting render",
      },
    ],
    gallery: [
      {
        image: commercialFrontImg,
        alt: "Commercial interior front view",
        caption: "Front view and first impression",
      },
      {
        image: commercialReceptionImg,
        alt: "Commercial reception interior",
        caption: "Reception and visitor zone",
      },
      {
        image: commercialWorkAreaImg,
        alt: "Commercial work area",
        caption: "Open work area planning",
      },
      {
        image: commercialMeetingImg,
        alt: "Commercial meeting area",
        caption: "Meeting and review corner",
      },
      {
        image: commercialCorridorImg,
        alt: "Commercial corridor interior",
        caption: "Circulation and wall treatment",
      },
      {
        image: commercialStorageImg,
        alt: "Commercial storage wall",
        caption: "Storage and utility planning",
      },
      {
        image: commercialPantryImg,
        alt: "Commercial pantry zone",
        caption: "Support zone and pantry detail",
      },
      {
        image: commercialDetailImg,
        alt: "Commercial interior detail",
        caption: "Material and lighting detail",
      },
      {
        image: commercialCabinImg,
        alt: "Commercial cabin interior",
        caption: "Cabin view",
      },
    ],
  };

export default UpComingProject;
